import Service from "../service";
import AuthService from "../AuthService";

const Auth = {
    login(data) {
      return Service.post("/api/login", data);
    },
    register(data){
        return Service.post('/api/register',data);
    },
    update(data) {
      return AuthService.post('/api/editUser', data)
    },
    getUser() {
        return AuthService.get("/api/details");
    },
    changePassword(data) {
      return AuthService.post('/api/changePassword', data)
    },
    logout() {
        return AuthService.post("/api/logout",data);
    },
};

export default Auth;
